$(document).ready(function () {
    if ($('[data-search=flights]').length > 0) {
        $('.flight-search--field [data-search=flights]').keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        });

        $('[data-search=flights]').autocomplete({            
            source: function (request, response) {
                console.log($("body").hasClass("design-b"));
                $.ajax({
                    url: '/WebServices/FlightInformation.asmx/FlightArrivalsAndDepartures',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify({ searchTerm: request.term, exactflight: false }),
                    success: function (data) {
                        if (data.d.length > 0) {
                            response($.map(data.d, function (item) {

                                return {
                                    label: item.fltnmbr + ' ' + item.origdest,
                                    fltnmbr: item.fltnmbr,
                                    value: item.fltnmbr,
                                    schedtime: item.schedtime,
                                    origdest: item.origdest,
                                    isArrival: item.isArrival,
                                    imgPath: item.imgPath
                                };
                            }));
                        } else {
                            var emptyResult = [1];
                            response($.map(emptyResult,
                                function () {
                                    return { value: '0' };
                                }));
                        }
                    }
                });
            },
            //focus: function (event, ui) {
            //    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            //        var element = $('.flight-search--field .ui-state-focus');
            //        window.location.href = $(element).attr('href');
            //    }
            //},
            open: function () {
                $(this).data('uiAutocomplete').menu.element.removeClass();
                $(this).data('uiAutocomplete').menu.element.addClass('results');
                $(this).data('uiAutocomplete').menu.element.removeAttr('style');
                $('.flight-search--field').append($(this).data('uiAutocomplete').menu.element);

            },
            close: function () {
            }
        }).data('ui-autocomplete')._renderItem = function (ul, item) {

            ul.addClass('results');
            var returnString;

            if (item.value != '0') {
                var term = this.term.split(' ').join('|');

                var regex = new RegExp('(' + term + ')', 'gi');

                var highlightFlightNumberText = item.fltnmbr.replace(regex, '<b>$1</b>');

                var highlightDestText = item.origdest.replace(regex, '<b>$1</b>');

                var toOrFrom;
                var departingArriving;

                if (item.isArrival) {
                    toOrFrom = 'From';
                    departingArriving = 'Arrive';
                } else {
                    toOrFrom = 'To';
                    departingArriving = 'Depart';
                }

                /*
                if ($("body").hasClass("design-b")) {
                    returnString = $('<a href="/ab-testing/flights/flight-detail?fltnmbr=' + item.fltnmbr + '"></a>');
                } else {
                    returnString = $('<a href="/flights/flight-detail?fltnmbr=' + item.fltnmbr + '"></a>');
                }
                */

                returnString = $("<a href='/flights/flight-detail?fltnmbr=" + item.flightNumber + "'></a>");

                var content = '<div class="results--image">' +
                    item.imgPath +
                    '<br/>' +
                    highlightFlightNumberText +
                    '</div>' +
                    '<div class="results--desination">' +
                    '<div><span>' + toOrFrom + '</span><h4>' + highlightDestText + '</h4></div>' +
                    '<div><span>' + departingArriving + '</span><h4>' + item.schedtime + '</h4></div>' +
                    '</div>';

                returnString.append(content);
            } else {
                item.value = '';
                returnString = $('<a href="/search?q=' + this.term + '">Sorry, we can\'t find a flight with that information. Click here to search our site for "' + this.term + '".</a>');
            }

            return $(returnString).data('ui-autocomplete-item', item).appendTo(ul);
        };
    }
});